/**
 * Fired when a support ticket changes on the admin queue, so the header's
 * Support badge can recount instead of showing the number it fetched when the
 * page first loaded.
 *
 * Lives here rather than beside the page that dispatches it: the header is
 * global chrome and must not import a route module to learn a string.
 */
export const SUPPORT_TICKETS_CHANGED_EVENT = "support-tickets-changed";
